// <div data-controller="fonts--show">
//
// </div>
import { Controller } from "@hotwired/stimulus";
import api from "@/utils/api";

// https://stimulus.hotwired.dev/reference
export default class extends Controller {
  static targets = [
      "fontEditorAll", "fontEditor", "fontSizeAll", "fontSizeLabel",
      "submit"
  ];
  static classes = [ "" ]
  static values = {};

  initialize() {
    this.debounceTimer = null;
    this.isSubmitting = false;
    this.lastSubmitTime = 0;
    // bind(this) 결과를 저장하여 동일한 참조 사용
    this.boundHandleSubmitEnd = this.handleSubmitEnd.bind(this);
  }

  onTyping(e) {
    this.retypeFonts();
  }

  submitWithinDebounce(e) {
    clearTimeout(this.debounceTimer);

    // 텍스트가 공란이면 요청하지 않음
    const text = e.target.value?.trim();
    if (!text || text === "") {
      return;
    }

    // 1초 debounce
    this.debounceTimer = setTimeout(() => {

      // 최소 간격 체크 (500ms)
      const now = Date.now();
      if (now - this.lastSubmitTime < 500) {
        return;
      }

      // 요청 중이면 무시
      if (this.isSubmitting) {
        return;
      }

      this.isSubmitting = true;
      this.lastSubmitTime = now;
      this.submitTarget.form.requestSubmit();
    }, 1000);
  }

  preventEnter(e) {
    // Enter 키로 인한 form 자동 제출 방지
    e.preventDefault();
  }

  retypeFonts() {
    const fontEditorValue = this.hasFontEditorAllTarget ? this.fontEditorAllTarget.value : null;

    this.fontEditorTargets.forEach((target) => {
      if (fontEditorValue === null || fontEditorValue === "") {
        target.value = target.dataset.defaultText;
      } else {
        target.value = fontEditorValue;
      }
    });
  }

  onResizeSliderScroll(e) {
    this.resizeFonts();
    this.fontSizeLabelTarget.innerText = `${e.target.value}px`;
  }

  onResizeSliderChange(e) {
    this.resizeFonts();
  }

  resizeFonts() {
    const fontSize = this.hasFontSizeAllTarget ? this.fontSizeAllTarget.value : null;
    if (fontSize === null) {
      return;
    }

    this.fontEditorTargets.forEach((target) => {
      target.style.fontSize = `${fontSize}px`;
      target.style.lineHeight = 1.5; // `${parseFloat(fontSize) * 4/3}px`;
    });
  }

  connect() {
    // Turbo form submit 완료 시 플래그 초기화
    this.element.addEventListener('turbo:submit-end', this.boundHandleSubmitEnd);
  }

  disconnect() {
    this.element.removeEventListener('turbo:submit-end', this.boundHandleSubmitEnd);
    clearTimeout(this.debounceTimer);
  }

  handleSubmitEnd(event) {
    // 요청 완료 후 플래그 초기화
    this.isSubmitting = false;
  }
}